module.exports = __webpack_public_path__ + "c90552e59e8c7b07bbbaaa4c8970f2da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars/avatar-1.png
// module id = 304
// module chunks = 1